__turbopack_context__.v({
  "alignItemsCenter": "FilterComponentNew-module__liAdCW__alignItemsCenter",
  "btnInnerIcon": "FilterComponentNew-module__liAdCW__btnInnerIcon",
  "btnPrimary": "FilterComponentNew-module__liAdCW__btnPrimary",
  "btnSecondary": "FilterComponentNew-module__liAdCW__btnSecondary",
  "clearIcon": "FilterComponentNew-module__liAdCW__clearIcon",
  "dFlex": "FilterComponentNew-module__liAdCW__dFlex",
  "filter": "FilterComponentNew-module__liAdCW__filter",
  "filterFlex": "FilterComponentNew-module__liAdCW__filterFlex",
  "filterNavbar": "FilterComponentNew-module__liAdCW__filterNavbar",
  "justifyContentSpaceBetween": "FilterComponentNew-module__liAdCW__justifyContentSpaceBetween",
  "loader": "FilterComponentNew-module__liAdCW__loader",
  "mobileDescription": "FilterComponentNew-module__liAdCW__mobileDescription",
  "moreLessButton": "FilterComponentNew-module__liAdCW__moreLessButton",
  "navContainer": "FilterComponentNew-module__liAdCW__navContainer",
  "search": "FilterComponentNew-module__liAdCW__search",
  "searchBox": "FilterComponentNew-module__liAdCW__searchBox",
  "searchButton": "FilterComponentNew-module__liAdCW__searchButton",
  "searchTerm": "FilterComponentNew-module__liAdCW__searchTerm",
});
